<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("adicionar-unidade-medida") }}
                        </h1>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            @click="onFecharModal"
                        >
                            {{ $t("cancelar") }}
                        </button>
                        <button
                            v-if="
                                (!isUpdate && permissao.create) ||
                                (isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div
                            class="column"
                            :class="autovinculo ? 'is-3' : 'is-6'"
                        >
                            <v-input 
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="unidadeMedida.idunidademedidaerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                :invalid="!unidadeMedida.idunidademedidaerp"
                                tooltipLabel="cod-ref"
                            />
                        </div>
                        <div
                            class="column"
                            :class="autovinculo ? 'is-3' : 'is-6'"
                        >
                            <v-input
                                :id="generateId(2)"
                                ref="descricaoInput"
                                v-model="unidadeMedida.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="descricao"
                                msg="msg-campo-obrigatorio"
                                :invalid="!unidadeMedida.descricao"
                                uppercase
                                required
                                tooltipLabel="info-descricao-generica"
                            />
                        </div>
                        <div v-if="autovinculo" class="column is-3">
                            <div class="perc-input">
                                <v-input
                                    :id="generateId(3)"
                                    v-model="percentualreajuste"
                                    placeholder="placeholder-preencha"
                                    :msg="'porcentagem-invalida'"
                                    :invalid="invalidReajuste"
                                    :onBlurFunction="validateReajuste"
                                    :maxlength="6"
                                    ref="reajusteFobInput"
                                    validchars="0123456789."
                                    title="perc-reajuste"
                                    tooltipSize="is-small"
                                    icon="percent"
                                    porcentagem
                                    required
                                />
                            </div>
                        </div>
                        <div v-if="autovinculo" class="column is-3">
                            <div class="fator-input">
                                <v-input
                                    :id="generateId(4)"
                                    v-model="fatorconversaoestoque"
                                    placeholder="placeholder-preencha"
                                    :msg="'porcentagem-invalida'"
                                    :invalid="invalidConversao"
                                    :onBlurFunction="validateConversao"
                                    :maxlength="6"
                                    ref="reajusteFobInput"
                                    validchars="0123456789."
                                    title="fator-conversao"
                                    tooltipSize="is-small"
                                    icon="percent"
                                    porcentagem
                                    required
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VenProdutoService from "@/services/vendas/produto/VenProdutoService";
import UnidadeMedidaService from "@/services/UnidadeMedidaService";
import UnidadeMedidaValidation from "@/services/validations/UnidadeMedidaValidation";
import Message from "@/models/Message";

export default {
    props: {
        assProdutoUnidadeMedidaIntegracao: {
            type: Boolean,
            default: false,
        },
        autovinculo: {
            type: Boolean,
            default: false,
        },
        idproduto: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            service: new UnidadeMedidaService(this.$http, this.$router),
            produtoService: new VenProdutoService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            unidadeMedida: {
                id: null,
                descricao: null,
                situacao: null,
            },
            isUpdate: false,
            situacao: { label: "ativo", id: 1 },
            percentualreajuste: 0,
            invalidReajuste: false,
            fatorconversaoestoque: 0,
            invalidConversao: false,
            validation: null
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "produtos",
            "venda-unidades-medida"
        );

        if (!this.permissao.create) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "unidade-medida" },
            });
        }
        this.validation = new UnidadeMedidaValidation(this.msgs)
    },
    methods: {
        validateReajuste() {
            this.invalidReajuste = !this.validatePorcentagem(
                this.percentualreajuste
            );
        },
        validateConversao() {
            this.invalidConversao = !this.validatePorcentagem(
                this.fatorconversaoestoque
            );
        },
        generateId(numberId) {
            return this.$route.name + "-" + numberId;
        },
        save() {
            this.isLoading = true;

            if (this.validation.validate(this.unidadeMedida, this.$refs)) {
                let unitTemp = Object.assign({}, this.unidadeMedida);
                unitTemp = this.mapTosave(unitTemp);
                unitTemp.situacao = this.situacao.id;

                this.isSaving = true;
                this.service
                    .save(unitTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = "msg-save-un-medida-sucesso";
                            this.msgs.push(new Message("success", msg, true));
                            if (!this.autovinculo) {
                                this.promptConfirmaVinculo(value.content);
                            } else {
                                this.autovincular(value.content);
                            }
                        } else {
                            let message = value.message;
                            if (message && this.$te(message)) {
                                if (message == "msg-codigo-duplicado-n") {
                                    this.msgs.push(new Message(
                                        'alert', 
                                        this.$t(message, { n: unitTemp.idunidademedidaerp }), 
                                        true, 
                                        false
                                    ));
                                } else {
                                    this.msgs.push(new Message('alert', message, true));
                                }

                                return;
                            }

                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .catch((e) => {
                        let message = e.body.message;
                        if (message && this.$te(message)) {
                            if (message == "msg-codigo-duplicado-n") {
                                this.msgs.push(new Message(
                                    'alert', 
                                    this.$t(message, { n: unitTemp.idunidademedidaer }), 
                                    true, 
                                    false
                                ));
                            } else {
                                this.msgs.push(new Message('alert', message, true));
                            }

                            return;
                        }

                        this.msgs.push(
                            new Message('error', 'msg-problema-realizar-acao', true)
                        );
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(
                    new Message("alert", "msg-campos-obrigatorios", true)
                );
                this.isLoading = false;
            }
        },
        promptConfirmaVinculo(unidademedida) {
            if (this.assProdutoUnidadeMedidaIntegracao) {
                setTimeout(() => this.$emit("fecharModal"), 1500);
            } else {
                this.$root.confirm({
                    message: this.$t("deseja-realizar-vinculo"),
                    onConfirm: (_) => {
                        this.$emit("cadastrado", unidademedida);
                    },
                    onCancel: (_) => {
                        this.$emit("fecharModal");
                    },
                });
            }
        },
        autovincular(un) {
            let unidademedida = [];
            unidademedida.push({
                idassprodutounidademedida: 0,
                descricao: un.descricao,
                idunidademedida: un.idunidademedida,
                idproduto: this.idproduto,
                fatorconversaoestoque: +this.fatorconversaoestoque,
                percentualreajuste: +this.percentualreajuste,
                unidademedida: un,
            });

            this.produtoService
                .addListUnMedidas(unidademedida)
                .then((value) => {
                    if (value.status === 409) {
                        this.$root.showMessage("alert", `${value.message}`);
                    } else if (value.status === 500) {
                        this.$root.showMessage("error", `${value.message}`);
                    } else {
                        this.$root.showMessage(
                            "success",
                            "msg-sucesso-ao-adicionar-associacao"
                        );
                        setTimeout(() => {
                            let sucesso = {
                                origem: "unidade-medida-vinculo",
                                obj: {
                                    id: un.id,
                                    label: un.id + " - " + un.descricao,
                                },
                            };
                            this.$emit("sucesso", sucesso);
                            this.$emit("fecharModal", true);
                        }, 200);
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$root.showMessage("alert", "msg-erro-load");
                });
        },
        onFecharModal() {
            this.$emit("fecharModal", true);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
